import { forwardRef, memo } from 'react'

import { IconV2 } from 'ui/components/Icon'

import { CircularProgress } from '../../CircularProgress'
import { ButtonProps } from './ButtonProps'

import * as SC from './styles'

export const Button = memo(
  forwardRef<HTMLButtonElement, ButtonProps>((props, ref) => {
    const {
      children,
      face = 'secondary',
      loading = false,
      iconLeft,
      iconRight,
      disabled,
      'data-qa': dataQA,
      ...rest
    } = props

    const data_qa = typeof children === 'string' && !dataQA ? children : dataQA

    const isPrimary = face === 'primary'
    const isSecondary = face === 'secondary'
    const isDanger = face === 'danger'
    const isTertiary = face === 'tertiary'
    const isInheritWhite = face === 'inherit white'

    return (
      <>
        {isPrimary && (
          <>
            {loading ? (
              <SC.PrimaryLoading ref={ref} disabled={true} data-qa={data_qa} data-testid={'button-loading'} {...rest}>
                <CircularProgress centered size={16} color="inverted" />
              </SC.PrimaryLoading>
            ) : (
              <SC.Primary ref={ref} disabled={disabled} data-qa={data_qa} {...rest}>
                <SC.Inner>{children}</SC.Inner>
              </SC.Primary>
            )}
          </>
        )}

        {isSecondary && (
          <>
            {loading ? (
              <SC.SecondaryLoading ref={ref} disabled={true} data-qa={data_qa} data-testid={'button-loading'} {...rest}>
                <CircularProgress centered size={16} color="default" />
              </SC.SecondaryLoading>
            ) : (
              <SC.Secondary ref={ref} disabled={disabled} data-qa={data_qa} {...rest}>
                <SC.Inner>{children}</SC.Inner>
              </SC.Secondary>
            )}
          </>
        )}

        {isDanger && (
          <>
            {loading ? (
              <SC.DangerLoading ref={ref} disabled={true} data-qa={data_qa} data-testid={'button-loading'} {...rest}>
                <CircularProgress centered size={16} color="inverted" />
              </SC.DangerLoading>
            ) : (
              <SC.Danger ref={ref} disabled={disabled} data-qa={data_qa} {...rest}>
                <SC.Inner>{children}</SC.Inner>
              </SC.Danger>
            )}
          </>
        )}

        {isTertiary && (
          <>
            {loading ? (
              <SC.BoxTertiaryLoading
                ref={ref}
                disabled={true}
                data-qa={data_qa}
                data-testid={'button-loading'}
                {...rest}
              >
                {iconLeft && <IconV2 name={iconLeft} />}
                <SC.Inner>
                  <CircularProgress centered size={16} color="brand" />
                </SC.Inner>
                {iconRight && <IconV2 name={iconRight} />}
              </SC.BoxTertiaryLoading>
            ) : (
              <SC.BoxTertiary ref={ref} disabled={disabled} data-qa={data_qa} {...rest}>
                {iconLeft && <IconV2 name={iconLeft} />}
                <SC.Inner>{children}</SC.Inner>
                {iconRight && <IconV2 name={iconRight} />}
              </SC.BoxTertiary>
            )}
          </>
        )}

        {isInheritWhite && (
          <>
            {loading ? (
              <SC.InheritWhiteLoading
                ref={ref}
                disabled={true}
                data-qa={data_qa}
                data-testid={'button-loading'}
                {...rest}
              >
                <CircularProgress centered size={16} color="inverted" />
              </SC.InheritWhiteLoading>
            ) : (
              <SC.InheritWhite ref={ref} disabled={disabled} data-qa={data_qa} {...rest}>
                <SC.Inner>{children}</SC.Inner>
              </SC.InheritWhite>
            )}
          </>
        )}
      </>
    )
  })
)
